import React from 'react';

import './App.css';
import { BrowserRouter as Router, Route , Routes, Navigate} from 'react-router-dom';
import { errorMachine, PromiseSesionContext } from './Machines/ErrorMachine';
import { useMachine } from '@xstate/react';
import ErrorHandler from './ErrorHandler/ErrorHandler';
import Layout from './Layout/Layout';
import Products from './Pages/Products/Products';
import { productShopMachine } from './Machines/ProductShopMachine';
import Proximamente from './Pages/Proximamente/Proximamente';
import Cartas from './Pages/Cartas/Cartas';
import { cartShopMachine } from './Machines/CartShopMachine';
import RolGuard from './RolGuard/RolGuard';
import { sesionMachine } from './Machines/SesionMachine';
import Login from './Pages/Login/Login';
import CartGuard from './RolGuard/CartGuard';
import LoginAdmin from './Pages/LoginAdmin/LoginAdmin';
import Panel from './Pages/Panel/Panel';
import CatalogoAdmin from './Pages/CatalogoAdmin/CatalogoAdmin';
import Order from './Pages/MomentOrder/Order';
import { GlobalDataProvider } from './Context/GlobalContext';
import CompleteOrder from './Pages/CompleteOrder/CompleteOrder';
import AdminOrder from './Pages/AdminOrder/AdminOrder';
import ManageOrder from './Pages/AdminOrder/ManageOrder';

function App() {
  const [error, sendError] = useMachine(errorMachine)
  const [cart, sendCart] = useMachine(productShopMachine)
  const [cartCard, sendCartCard] = useMachine(cartShopMachine)
  const [sesion, sendSesion] = useMachine(sesionMachine)



  return (
    <GlobalDataProvider>
    <Router>
      <PromiseSesionContext.Provider value={{ error, sendError, cart, sendCart, cartCard, sendCartCard, sesion, sendSesion}}>
        <ErrorHandler>
          <RolGuard> 
            <CartGuard>
              <Layout>
                <Routes>
                  <Route path="/productos" element={<Products />}/>
                  <Route path="/proximamente" element={<Proximamente />}/>
                  <Route path="/cartas" element={<Cartas />}/>
                  {/* <Route path="/completar-compra" element={<CompleteOrder />}/> */}


                  {/* Rutas admin */}
                  <Route path="/loginadmin" element={<LoginAdmin />}/>
                  <Route path="/catalogo" element={<CatalogoAdmin />}/>
                  <Route path="/orden" element={<Order />}/>
                  <Route path="/orden-admin" element={<AdminOrder />}/>
                  <Route path="/orden-admin/:id" element={<ManageOrder />}/>
                  <Route path="/ajustes" element={<></>}/>



                  {/* <Route path="/panel" element={<Cartas />}/>
                  <Route path="/ingreso" element={<Login />}/> */}
                      <Route
                          path="*"
                          element={<Navigate to="/productos" replace />}
                      />
                </Routes>
              </Layout>
            </CartGuard>
          </RolGuard>
        </ErrorHandler>
      </PromiseSesionContext.Provider>
    </Router>
    </GlobalDataProvider>
  );
}

export default App;
